import { useLocation, useNavigate } from 'react-router-dom';
import { Typography, Stack, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

export default function EditHeaderDef({ scName, pageType }) {

    const navigate = useNavigate();
    const location = useLocation();
    const [isCopyScheme, setIsCopyScheme] = useState(false);
    useEffect(() => {
        setIsCopyScheme(location.state?.data?.copyScheme);
    }, [location]);

    const handleClick = () => {
        navigate('/scheme/scheme-definition');      
        
    } 
    return (
        <Stack direction='row' alignItems='center' justifyContent='space-between' sx={{ bgcolor: (pageType === 'add' || isCopyScheme) ? '#20b2aa' : '#3B3C78', height: 40, mb: 2, borderRadius: '8px', marginBottom: '0.2rem' }} >
            <Stack direction='column' alignItems='flex-start' justifyContent='flex-start' spacing={1}>
                <Typography variant='body1' sx={{ fontSize: '1rem', color: '#fff', lineHeight: '0.8rem', }} style={{ marginLeft: '10px' }} >
                    {scName}
                </Typography>
            </Stack>
            <Box flexGrow={1} />
            <IconButton onClick={handleClick} sx={{ color: '#fff' }}>
                <CloseIcon sx={{ width: '20px', height: '20px' }} />
            </IconButton>
        </Stack >

    );
}

EditHeaderDef.propTypes = {  
    scName: PropTypes.string,
    pageType: PropTypes.string
};